<script>
import { mapState } from "vuex";

import { validateAndSubmit } from "../../../mixins/validateAndSubmit";
import { validationClass } from "../../../mixins/validationClass";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";

export default {
  data() {
    return {
      i_know_who_i_am: 0,
      form: {
        active: true,
      },
      disableOnSubmit: false,
      dictionary: {
        en: {
          messages: {
            between: () =>
              "The total for the highlighted questions must equal 100%",
          },
          attributes: {
            who_are_you: "Who are you?",
            how_content_are_you: "How content are you?",
            extent_living: "To what extent do you feel you are... Living?",
            extent_existing: "To what extent do you feel you are... Existing?",
            extent_being: "To what extent do you feel you are... Being?",
            extent_doing: "To what extent do you feel you are... Doing?",
            extent_becoming: "To what extent do you feel you are... Becoming?",
            extent_thinking: "To what extent do you feel you are... Thinking?",
            extent_talking: "To what extent do you feel you are... Talking?",
            extent_acting:
              "To what extent do you feel you are... Acting/Doing?",
            how_well_do_i_know_myself: "How well do I know myself?",
          },
        },
      },
      living_existing_changed: false,
      being_doing_becoming_changed: false,
      thinking_talking_changed: false,
      start_watching: false,
    };
  },

  props: ["url", "getUrl", 'scaleUrl', 'scale'],

  mixins: [validateAndSubmit, validationClass],

  computed: {
    living_existing_total: function () {
      return (
          this.form.extent_living || this.form.extent_existing
            ? parseInt(this.form.extent_living) + parseInt(this.form.extent_existing)
            : 100
      );
    },
    living_existing_error_class: function () {
      if (this.living_existing_changed) {
        return this.living_existing_total != 100 &&
          this.living_existing_total != null
          ? "invalid"
          : "";
      }
    },
    being_doing_becoming_total: function () {
      return (
          this.form.extent_being || this.form.extent_doing || this.form.extent_becoming
          ? parseInt(this.form.extent_being) + parseInt(this.form.extent_doing) + parseInt(this.form.extent_becoming)
          : 100
      );
    },
    being_doing_becoming_error_class: function () {
      if (this.being_doing_becoming_changed) {
        return this.being_doing_becoming_total != 100 &&
          this.being_doing_becoming_total != null
          ? "invalid"
          : "";
      }
    },
    thinking_talking_total: function () {
      return (
          this.form.extent_thinking || this.form.extent_talking || this.form.extent_acting
        ? parseInt(this.form.extent_thinking) + parseInt(this.form.extent_talking) + parseInt(this.form.extent_acting)
        : 100
      );
    },
    thinking_talking_error_class: function () {
      if (this.thinking_talking_changed) {
        return this.thinking_talking_total != 100 &&
          this.thinking_talking_total != null
          ? "invalid"
          : "";
      }
    },
  },

  created() {},

  mounted() {
    this.getData();
    this.i_know_who_i_am = this.scale;
    this.$validator.localize(this.dictionary);
  },

  watch: {
    living_existing_total: function () {
      if (this.start_watching) {
        this.living_existing_changed = true;
      }
    },
    being_doing_becoming_total: function () {
      if (this.start_watching) {
        this.being_doing_becoming_changed = true;
      }
    },
    thinking_talking_total: function () {
      if (this.start_watching) {
        this.thinking_talking_changed = true;
      }
    },
  },

  methods: {
    getData() {
      var self = this;
      axios
        .get(this.getUrl, {
          params: {},
        })
        .then((response) => {
          self.form = response.data.data;
          var entries = Object.entries(self.form);

          entries.forEach(([key, value]) => {
            if (value == null && key != "who_are_you") {
              self.form[key] = 0;
            }
          });
        })
        .finally((response) => {
          self.start_watching = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    validate() {
      this.living_existing_changed = true;
      this.being_doing_becoming_changed = true;
      this.thinking_talking_changed = true;
      this.validateAndSubmit("who-are-you-create-edit-form");
    },

    updateScale() {
        axios
            .put(this.scaleUrl,
                {
                    scale: this.i_know_who_i_am,
                }
            )
            .then(response => {
                this.$root.$refs.toastr.s(response.data.message);
            })
            .catch(error => {
                console.log(error);
                this.$root.$refs.toastr.e("ERROR");
            });
    },
  },

  components: {
    VueSlider,
  },
};
</script>
